import React from 'react';

import Tooltip from '@atlaskit/tooltip';

import TestTypeColorUtil from '@qality/common-components/src/molecules/TestTypeComponent/TestTypeColor.util';
import TestTypeIcon from '@qality/common-components/src/molecules/TestTypeComponent/TestTypeIcon';
import { TestType, TestTypeAppearance } from '@qality/common-model';
import useOverflowObserver from '@qality/common-utils/src/hooks/useOverflowObserver';

import {
  TestTypeDescriptionStyled,
  TestTypeLabelStyled,
  TestTypeNameStyled,
  TestTypeOptionIconStyled,
  TestTypeOptionWrapper,
} from './TestTypePopupSelectOption.styled';

type Props = {
  testType: TestType;
  appearance?: TestTypeAppearance;
};

export default function TestTypePopupSelectOption({
  testType,
  appearance,
}: Props): JSX.Element {
  const { ref: nameRef, isOverflowing: isNameOverflowing } =
    useOverflowObserver();
  const { ref: descriptionRef, isOverflowing: isDescOverflowing } =
    useOverflowObserver();

  const isOverflowing = isNameOverflowing || isDescOverflowing;

  const tooltipContent = `${testType.name} - ${testType.description}`;
  return (
    <Tooltip content={isOverflowing && tooltipContent} position='right'>
      <TestTypeOptionWrapper>
        <TestTypeOptionIconStyled
          backgroundColor={TestTypeColorUtil.getBackgroundColor(
            appearance,
            testType.colorName
          )}
        >
          <TestTypeIcon
            iconName={testType.iconName}
            colorName={testType.colorName}
            appearance={appearance}
            size='medium'
            label='test-type-icon '
          />
        </TestTypeOptionIconStyled>
        <TestTypeLabelStyled>
          <TestTypeNameStyled innerRef={nameRef}>
            {testType.name}
          </TestTypeNameStyled>
          <TestTypeDescriptionStyled innerRef={descriptionRef}>
            {testType.description}
          </TestTypeDescriptionStyled>
        </TestTypeLabelStyled>
      </TestTypeOptionWrapper>
    </Tooltip>
  );
}
